import { render } from "./007-InnovationEntrepreneurshipPage.vue?vue&type=template&id=460bba65&scoped=true"
import script from "./007-InnovationEntrepreneurshipPage.vue?vue&type=script&lang=js"
export * from "./007-InnovationEntrepreneurshipPage.vue?vue&type=script&lang=js"

import "@/assets/css/news.css?vue&type=style&index=0&id=460bba65&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460bba65"]])

export default __exports__